import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    circle: {
      position: 'absolute',
    },
    header: {
      height: '91px',
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.2em',
      fontWeight: 'bold',
      margin: '0 0 2vh',
      textTransform: 'uppercase',
    },
    metricGridItems: {
      marginTop: theme.spacing(3),
    },
    metricGridItemsFull: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    paper: {
      boxShadow:
        '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    },
    metricBoxChart: {
      padding: theme.spacing(2),
      height: '100%',
    },
    channelSelect: {
      minWidth: '340px',
      '& > *': {
        width: '100%',
      },

      [theme.breakpoints.down('md')]: {
        minWidth: '150px',
      },
    },
    loading: {
      alignItems: 'center',
      backgroundColor: 'rgba(109, 114, 120, 0.1)',
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100vw',
    },
    listView: {
      alignItems: 'center',
      flexDirection: 'column',
      height: '20vh',
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
    noData: {
      alignItems: 'center',
      alignSelf: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '80vh',
      justifyContent: 'center',
      textAlign: 'center',
      width: '100%',
    },
  })
);
